module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold.5bc22bba.eot";